import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DpDatePickerModule} from 'ng2-date-picker';
import {ClickOutsideDirective} from './directives/click-outside.directive';
import {ColorClickDirective} from './directives/color-click.directive';
import {DisableDirective} from './directives/disable.directive';
import {DraggableDialogDirective} from './directives/draggable-dialog.directive';
import {ResizableDialogDirective} from './directives/resizable-dialog.directive';
import {UserCircleComponent} from './user-circle/user-circle.component';
import {DeletedMapFilterPipe} from './pipes/deleted-map-filter.pipe';
import {MapFilterPipe} from './pipes/map-filter.pipe';
import {TextCutterPipe} from './pipes/text-cutter.pipe';
import {UserFilterPipe} from './pipes/user-filter.pipe';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MaterialModule} from 'src/app/material.module';
import {VersionsListComponent} from './versions/versions-tree/versions-list.component';
import {VersionsHistoryPopupComponent} from './versions/versions-history-popup/versions-history-popup.component';
import {VersionHistoryTreeComponent} from './versions/versions-history-popup/version-history-tree/version-history-tree.component';
import {MakeReadyForReleasePopupComponent} from './versions/versions-tree/make-ready-for-release-popup/make-ready-for-release-popup.component';
import {VersionDoesNotExistPopupComponent} from './versions/version-does-not-exist-popup/version-does-not-exist-popup.component';
import {CoreModule} from '../../core/core.module';
import {GetVersionClassPipe} from './versions/get-version-class.pipe';
import {VersionStatePipe} from './versions/version-state.pipe';
import {FormHasErrorPipe} from './pipes/form-has-error.pipe';
import {VersionNamePipe} from './pipes/version-name.pipe';
import {GetVersionNamePipe} from './pipes/get-version-name.pipe';
import {ThemeCanPastePipe} from './pipes/theme-can-paste.pipe';
import {GetResourceTypesInActivityPipe} from './pipes/get-resource-types-in-activity.pipe';
import {DiagramStatePipe} from './pipes/diagram-state.pipe';
import {ReleaseTagClassPipe} from './pipes/release-tag-class.pipe';
import {ReleaseNamePipe} from './pipes/release-name.pipe';
import {RequestAuthorisationPopupComponent} from './versions/versions-tree/request-authorisation-popup/request-authorisation-popup.component';
import {GetScreenshotConfigPipe} from './pipes/get-screenshot-config.pipe';
import {GetDiagramStateLabelPipe} from './pipes/get-diagram-state-label.pipe';
import {IsAuthorisationInProgressPipe} from './versions/is-authorisation-in-progress.pipe';
import {GetAuthorisableIconPipe} from './pipes/get-authorisable-icon.pipe';
import {TooltipOnOverflowDirective} from './directives/tooltip-on-overflow.directive';
import {AuthorisationTaskStatusPipe} from './pipes/authorisation-task-status.pipe';
import {GetDisplayResourceTypePipe} from './pipes/get-display-resource-type.pipe';
import {LineFormButtonsetComponent} from './components/line-form-buttonset/line-form-buttonset.component';
import {ColorPickerComponent} from './color-picker/color-picker.component';
import {FullColorPickerComponent} from './full-color-picker/full-color-picker.component';
import {TranslateModule} from '@ngx-translate/core';
import {MatInputModule} from '@angular/material/input';
import {TrialModule} from '@q9elements/ui-kit/components';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    CoreModule,
    DpDatePickerModule,
    MatInputModule,
    ClickOutsideDirective,
    ColorClickDirective,
    DisableDirective,
    DraggableDialogDirective,
    ResizableDialogDirective,
    UserCircleComponent,
    DeletedMapFilterPipe,
    MapFilterPipe,
    TextCutterPipe,
    UserFilterPipe,
    VersionsListComponent,
    VersionsHistoryPopupComponent,
    VersionHistoryTreeComponent,
    MakeReadyForReleasePopupComponent,
    VersionDoesNotExistPopupComponent,
    FullColorPickerComponent,
    GetVersionClassPipe,
    VersionStatePipe,
    FormHasErrorPipe,
    VersionNamePipe,
    GetVersionNamePipe,
    ThemeCanPastePipe,
    GetResourceTypesInActivityPipe,
    DiagramStatePipe,
    ReleaseTagClassPipe,
    ReleaseNamePipe,
    RequestAuthorisationPopupComponent,
    GetScreenshotConfigPipe,
    GetDiagramStateLabelPipe,
    IsAuthorisationInProgressPipe,
    GetAuthorisableIconPipe,
    TooltipOnOverflowDirective,
    AuthorisationTaskStatusPipe,
    GetDisplayResourceTypePipe,
    LineFormButtonsetComponent,
    ColorPickerComponent,
    TrialModule
  ],
  exports: [
    ClickOutsideDirective,
    ColorClickDirective,
    DisableDirective,
    DraggableDialogDirective,
    ResizableDialogDirective,
    UserCircleComponent,
    DeletedMapFilterPipe,
    MapFilterPipe,
    TextCutterPipe,
    UserFilterPipe,
    VersionsListComponent,
    VersionsHistoryPopupComponent,
    VersionHistoryTreeComponent,
    MakeReadyForReleasePopupComponent,
    VersionDoesNotExistPopupComponent,
    FullColorPickerComponent,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    FormHasErrorPipe,
    ThemeCanPastePipe,
    GetResourceTypesInActivityPipe,
    DiagramStatePipe,
    AuthorisationTaskStatusPipe,
    GetDisplayResourceTypePipe,
    LineFormButtonsetComponent,
    ColorPickerComponent
  ]
})
export class EditorInterfaceSharedModule {}
